import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: auto;
	gap: 7px;
	margin-top: 15px;
	padding-right: 12px;
`;

export const ButtonsContainer  = styled.div`
	display: flex;
	gap: 8px;
	
`